import { StrictMode } from 'react'
import { createRoot } from 'react-dom/client'
import { RootApp } from './root-app'
import './styles.css'
import './ui.css'

const root = document.getElementById('root')

if (!root) {
  throw new Error('Tride root element was not found.')
}

createRoot(root).render(
  <StrictMode>
    <RootApp />
  </StrictMode>,
)
